import { render } from "./FormFileInput.vue?vue&type=template&id=3351fbb4&ts=true"
import script from "./FormFileInput.vue?vue&type=script&lang=ts"
export * from "./FormFileInput.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__